import React, { useMemo } from "react";
import { Line } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";


Chart.register(...registerables);

const EnergyConsumptionCard = ({ labels, data1, title, colorcode, darkMode }) => {

  const hexToRgba = (hex, opacity) => {
    hex = hex.replace(/^#/, "");
    if (hex.length === 3) {
      hex = hex.split("").map((char) => char + char).join("");
    }

    // Convert hex to RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  const gradientBg = useMemo(
    () => (context) => {
      const ctx = context.chart.ctx;
      if (!ctx) return null;

      const gradient = ctx.createLinearGradient(0, 0, 0, 400);
      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");
      gradient.addColorStop(0, hexToRgba(colorcode, 0.3));
      return gradient;
    },
    [colorcode]
  );

  const chartData = useMemo(() => ({
    labels,
    datasets: [
      {
        label: title,
        data: data1,
        borderColor: hexToRgba(colorcode, 0.8),
        pointBackgroundColor: hexToRgba(colorcode, 1),
        pointBorderColor: hexToRgba(colorcode, 1),
        backgroundColor: gradientBg,
        tension: 0.4,
        fill: true,
        pointRadius: 4,
        pointHoverRadius: 6,
      },
    ],
  }), [labels, data1, title, colorcode, gradientBg]);

  const chartOptions = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        bottom: 0,   
        top: 8,
        left: 0,
        right: 0,
      },
    },
    animation: false,
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          padding: 4,
          color: darkMode ? "white" : "#344767",
        },
      },

      y: {
        grid: {
          display: true,
          color: "rgba(0, 0, 0, 0.04)",
        },
        ticks: {
          padding: 4,
          color: darkMode ? "white" : "#344767",
          callback: (value) => {
            if (title === "CO₂ Saved") {
              return (value * 0.58).toLocaleString(undefined, {
                maximumFractionDigits: 2,
              });
            }
            return value.toLocaleString();
          },
        },
        beginAtZero: true,
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => {
            const value = context.raw;
            const unitMap = { Energy: "kWh", Revenue: "د.إ", "CO₂ Saved": "kg" };
            const unit = unitMap[title] || "";
            return title === "Revenue"
              ? `${unit} ${value}`
              : `${value} ${unit}`;
          },
        },
      },
    },
  }), [darkMode, title]);


  return (
    <div
    style={{ position: "relative", height: "100%", width: "100%" }}
    >
      <Line data={chartData} options={chartOptions} />
    </div>
  );
};

export default React.memo(EnergyConsumptionCard);
